export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/dfffdcc654f425d556d7485c2bf841db.svg";